
import React from "react";
import { CampaignData } from "./CampaignBuilder";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent } from "@/components/ui/card";

interface CampaignDetailsFormProps {
  campaignData: CampaignData;
  updateCampaignData: (data: Partial<CampaignData>) => void;
}

export const CampaignDetailsForm: React.FC<CampaignDetailsFormProps> = ({
  campaignData,
  updateCampaignData,
}) => {
  return (
    <div className="space-y-6">
      <div className="space-y-1.5">
        <Label htmlFor="name">Campaign Name</Label>
        <Input
          id="name"
          value={campaignData.name}
          onChange={(e) => updateCampaignData({ name: e.target.value })}
          placeholder="Summer Newsletter 2023"
        />
        <p className="text-sm text-slate-500 mt-1">
          Internal name for your campaign. Only you will see this.
        </p>
      </div>

      <div className="space-y-1.5">
        <Label htmlFor="subject">Email Subject Line</Label>
        <Input
          id="subject"
          value={campaignData.subject}
          onChange={(e) => updateCampaignData({ subject: e.target.value })}
          placeholder="Your Weekly Newsletter is Here"
        />
        <p className="text-sm text-slate-500 mt-1">
          Subject line recipients will see in their inbox.
        </p>
      </div>

      <div className="space-y-1.5">
        <Label htmlFor="previewText">Preview Text</Label>
        <Textarea
          id="previewText"
          value={campaignData.previewText}
          onChange={(e) => updateCampaignData({ previewText: e.target.value })}
          placeholder="A brief summary shown in the inbox after the subject line"
          rows={3}
        />
        <p className="text-sm text-slate-500 mt-1">
          Short summary that appears in email clients after the subject line.
        </p>
      </div>

      <Card className="border border-amber-100 bg-amber-50">
        <CardContent className="p-4">
          <h4 className="text-sm font-medium text-amber-800">Campaign Tips</h4>
          <ul className="text-xs text-amber-700 list-disc pl-4 mt-2 space-y-1">
            <li>Keep subject lines under 50 characters for best results</li>
            <li>Use preview text to complement your subject line, not repeat it</li>
            <li>Personalization in subject lines can increase open rates</li>
            <li>Avoid spam trigger words like "free," "guarantee," and excessive punctuation</li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
};
